module.exports = __webpack_public_path__ + "img/1HONEY.0e1154c2.png";